export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TeamMemberListItem.vue?vue&type=template&id=363d2d38&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TeamMemberListItem.vue?vue&type=template&id=363d2d38&scoped=true&
// module id = 188
// module chunks = 0